import React from 'react';

import { buttonClass, ButtonSize, ButtonVariant } from './Button';

export interface IconButtonProps
  extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'aria-label' | 'children'> {
  /** Required: an icon has no text for a screen reader to announce. */
  label: string;
  /** The icon itself. */
  children: React.ReactNode;
  variant?: ButtonVariant;
  size?: ButtonSize;
  ref?: React.Ref<HTMLButtonElement>;
}

const IconButton: React.FC<IconButtonProps> = ({
  label,
  variant = 'ghost',
  size = 'md',
  className,
  type = 'button',
  children,
  ...rest
}) => (
  <button
    {...rest}
    type={type}
    aria-label={label}
    title={rest.title ?? label}
    className={buttonClass(
      variant,
      size,
      ['ui-btn--icon', className || ''].filter(Boolean).join(' '),
    )}
  >
    {children}
  </button>
);

export default IconButton;
